module.exports = __webpack_public_path__ + "static/media/logo_large.371697b6.png";